import { SquarePlus } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/** Centred placeholder for screens with nothing to show yet. */
export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center px-5 py-[100px] text-center text-ink-faint',
        className,
      )}
    >
      <div className="mb-[18px] flex h-14 w-14 items-center justify-center rounded-2xl bg-line-subtle">
        {icon ?? <SquarePlus size={26} strokeWidth={1.8} className="text-ink-faint" />}
      </div>
      <div className="mb-1.5 text-[17px] font-bold text-ink-body">{title}</div>
      {description ? (
        <p className="max-w-[340px] text-[13.5px] font-medium leading-[1.5]">{description}</p>
      ) : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
